import { Routes, Route, Navigate } from "react-router-dom";
import StudentDashboard from "./StudentDashboard";
import StudentLayout from "../../layouts/StudentLayout";
import ModulePage from "./ModulePage";
import SwitchCard from "../question-types/SwitchCard";
import Speaking from "../question-types/Speaking";
import SentenceBuilder from "../question-types/SentenceBuilder";
import PlacementTestPage from "../placement-test/PlacementTestPage";
import MyClassroomPage from "./MyClassroomPage";
import StudyContentSession from "./StudyContentSession";
import { StudentClassroomProvider } from "../../context/StudentClassroomContext";
import ProfilePage from "../shared/ProfilePage";

const Student = () => {
  return (
    <StudentClassroomProvider>
      <StudentLayout>
        <Routes>
          <Route index element={<Navigate to="my-classroom" replace />} />
          <Route path="profile" element={<ProfilePage />} />

          <Route
            path="placement-test/*"
            element={<PlacementTestPage />}
          ></Route>
          <Route path="/dashboard" element={<StudentDashboard />} />
          <Route path="my-classroom" element={<MyClassroomPage />} />

          {/* Module pages with nested question types */}
          <Route path="my-classroom/:weekId" element={<MyClassroomPage />} />
          <Route
            path="my-classroom/module/:moduleId"
            element={<ModulePage />}
          />
          <Route
            path="my-classroom/module/:moduleId/question/:questionId"
            element={<ModulePage />}
          />

          {/* Study Content Routes */}
          <Route
            path="my-classroom/study-content/:sessionId"
            element={<StudyContentSession />}
          />

          {/* Question type routes - nested under modules */}
          {/* <Route
            path="my-classroom/module/:moduleId/question/:questionId/switch-card"
            element={<SwitchCard />}
          /> */}
          <Route
            path="my-classroom/module/:moduleId/question/:questionId/speaking"
            element={<Speaking />}
          />
          <Route
            path="my-classroom/module/:questionId/question/:questionId/sentence-builder"
            element={<SentenceBuilder />}
          />
        </Routes>
      </StudentLayout>
    </StudentClassroomProvider>
  );
};

export default Student;
